import script from "./DynamicByMonth.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicByMonth.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicByMonth.vue?vue&type=style&index=0&id=ca6ff54c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca6ff54c"]])

export default __exports__